// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1SIYt","visuallyhidden":"_1MWYh","hide-text":"_2vs3x","center":"WC_61","noprint":"hX-Rs","root":"_3ThgB","caption":"_3jwl_","fullcaption":"_9JHK_","captionButton":"_2pMt3","image":"_103QJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-image/styles/default.scss
 ** module id = 1007
 ** module chunks = 2
 **/